var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsWhiteMovil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.945,
    height: 19.929,
    viewBox: "0 0 19.945 19.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsWhiteMovil",
    "data-name": "Grupo 471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_238",
    "data-name": "Trazado 238",
    d: "M597.535,557.054a8.237,8.237,0,0,1-4.524-1.352l-3.154,1,1.018-3.038a8.073,8.073,0,0,1-1.569-4.79,6.184,6.184,0,0,1,.05-.785,8.233,8.233,0,0,1,16.39.15c.017.217.017.434.017.634a8.213,8.213,0,0,1-8.228,8.179Zm4.49-6.209c-.25-.117-1.419-.7-1.635-.784-.234-.067-.384-.117-.551.133a11.649,11.649,0,0,1-.752.918c-.15.167-.283.184-.517.067a6.275,6.275,0,0,1-1.936-1.185,7.085,7.085,0,0,1-1.336-1.636c-.134-.251-.017-.367.1-.5a3.058,3.058,0,0,0,.367-.417.424.424,0,0,0,.084-.1,2.335,2.335,0,0,0,.151-.284.409.409,0,0,0-.016-.417c-.051-.117-.534-1.3-.735-1.769-.2-.484-.4-.4-.534-.4-.15,0-.3-.017-.467-.017a.821.821,0,0,0-.634.3,2.661,2.661,0,0,0-.717,2.787,5.234,5.234,0,0,0,.851,1.652,9.681,9.681,0,0,0,4.089,3.589c2.454.951,2.454.634,2.888.6a2.385,2.385,0,0,0,1.62-1.135,1.9,1.9,0,0,0,.133-1.135c-.05-.083-.217-.15-.451-.267Zm5.292-2.2a9.782,9.782,0,0,0-19.546-.184,3.494,3.494,0,0,0-.017.417,9.714,9.714,0,0,0,1.4,5.024l-1.769,5.208,5.424-1.719a9.815,9.815,0,0,0,14.521-8.512c0-.083-.016-.15-.016-.234Z",
    transform: "translate(-587.387 -539.178)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsWhiteMovil);
export default __webpack_public_path__ + "static/media/WhatsWhiteMovil.9464ed9fd6676007881e4299f03089a5.svg";
export { ForwardRef as ReactComponent };